module.exports = __webpack_public_path__ + "static/assets/83e0a70c03975d47b1b3b1d1b756eba0.svg";